import { scaleLinear } from 'd3-scale';

export const InscribeAnalyticsBluePalette = ['#006ADC', '#B7D9F8', '#E1F0FF'];
export const InscribeAnalyticsRedPalette = ['#CD2B31', '#F9C6C6', '#FFE5E5'];

export const getPaletteColor = (data, idx, palette) => {
  const paletteFn = scaleLinear().domain([1, data.length]).range(palette);
  return paletteFn(idx);
};
